import React, { useEffect, useState } from 'react';
import Select, { components } from 'react-select';

const controlStyles = {
    borderRadius: '1px solid black',
    color: 'white',
    width: '100%',
};

const ControlComponent = (props) => (
    <div style={controlStyles}>
        <components.Control {...props} />
    </div>
);

const BusVendorDropdown = ({ getBusVendor, clearSelect }) => {
    const [busVendors, setBusVendors] = useState([]);
    const [selectedOption, setSelectedOption] = useState('');

    const options = busVendors.map((item => ({ value: item.id, label: item.vendor_name, buses: item.buses })));

    const { REACT_APP_API_BACKEND_URL } = process.env;

    useEffect(() => {
        const getBusVendors = async () => {
            const busVendorFromServer = await fetchBusVendors();
            setBusVendors(busVendorFromServer);
        };
        
        clearSelect && setSelectedOption(null)

        getBusVendors();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clearSelect]);

    const fetchBusVendors = async () => {
        try {
            const res = await fetch(REACT_APP_API_BACKEND_URL + '/api/busdriver/vendor', { mode: 'cors' });
            const data = await res.json();
            
            return data;
        }
        catch (err) {
            console.log(err)
        }
    };

    const handleChange = (selectedOption) => {
        setSelectedOption(selectedOption);
        
        getBusVendor(selectedOption);
    };

    return (
        <Select
            placeholder={'Select a bus vendor...'}
            components={{ Control: ControlComponent }}
            isClearable
            value={selectedOption}
            onChange={handleChange}
            options={options}
        />
    );
};

export default BusVendorDropdown;
